import React from 'react';import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {saveUser, unlockUser, deleteUser, loadUsers, inviteExternalUsers} from '../../actions/userActions';
import { Button, Collapse, Label, Input, FormGroup} from 'reactstrap';
import Select from 'react-select';
import {toastr} from 'react-redux-toastr';
import {EMPTY_GUID, IsInRole, ROLE_SuperUser, IsCurrentUser, ROLE_LocationUser, ROLE_ClientUser, BASE_URL, ROLE_Admin, allowUserWithRoles, ROLE_OfficeUser} from '../../constants';
import ContactView from '../Contacts/ContactView';
import {apiRequest} from "../../utils/request";
import 'react-table/react-table.css';
import UserClientLocationControl from './UserClientLocationControl';
import { push } from '../../utils/navigation';
import { mustBeArray, requestHasError } from '../../utils/lib';
import _ from 'lodash-es';
import PasswordStrengthInstruction from './PasswordStrengthInstruction';
import { withRouter } from '../../utils/withRouter';

class ManageUserControl extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedUser: null,
      isResetPassword: false,
      waitingUpdate: false,
      authRequestColumns: [],
      communicationNotificationList: [],
      sendInviteLoading: false,
      syncToB2C: true,
      createB2CIfNotExists: false,
    };

    this.contactRef = React.createRef();
    this.userLocationsRef = React.createRef();

    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.handleUserFieldChange = this.handleUserFieldChange.bind(this);
    this.handleSaveUser = this.handleSaveUser.bind(this);
    this.handleDeleteUser = this.handleDeleteUser.bind(this);
    this.loadUser = this.loadUser.bind(this);
    this.handleCommunicationNotificationFieldChange = this.handleCommunicationNotificationFieldChange.bind(this);
  }

  handleUserFieldChange(e) {
    let x = {...this.state.selectedUser};
  
    if(e.target.type=="checkbox"){
      x[`${e.target.name}`] = e.target.checked;
    }
    else if(e.target.type=='number') {
      x[`${e.target.name}`] = e.target.value.replace(/\D/g,'');
    }
    else {
      x[`${e.target.name}`] = e.target.value;
    }

    this.setState({selectedUser: x});
  }

  handleRoleChange(val) {
    this.setState({selectedUser: {...this.state.selectedUser, roles: val}});
  }

  handleSaveUser(){
    let {selectedUser} = this.state;
    let userContact = this.contactRef.current.getCurrentState();
    if(userContact == null){
      toastr.error('Please ensure all fields are completed');
      return;
    }
    if(selectedUser.userName.trim() != '' && userContact){
      this.setState({waitingUpdate: true});

      let currentCommunications = mustBeArray(selectedUser && selectedUser.userContact && selectedUser.userContact.communications).reduce((a,b) => a.concat([b.detail]),[]);
      let updatedNotificationCommunications = mustBeArray(selectedUser.userNotificationCommunications).filter(data => currentCommunications.includes(data.name));
      updatedNotificationCommunications = mustBeArray(updatedNotificationCommunications).map((data) => {
        let tempData = {...data};
        delete tempData.name;
        delete tempData.type;
        return tempData;
      });
      selectedUser.userNotificationCommunications = updatedNotificationCommunications;
      this.props.dispatch(saveUser({...this.state.selectedUser, userContact, syncToB2C: this.state.syncToB2C, createB2CIfNotExists: this.state.syncToB2C && this.state.createB2CIfNotExists})).then(x => {
        if(!(x.error || x.data.Message)){
          // Check if user is location or client user and redirect to edit screen where they can link client/location
          const isClientUser = mustBeArray(selectedUser.roles).find(o => o.roleName === ROLE_ClientUser);
          const isLocationUser = mustBeArray(selectedUser.roles).find(o => o.roleName === ROLE_LocationUser);
          if((isClientUser || isLocationUser) && selectedUser.userId === EMPTY_GUID){
            this.props.dispatch(push(`${BASE_URL}/manage/users/${x.data && x.data.userId}?action=linkClientLocation`));
            return this.loadUser(x.data && x.data.userId);
          }
          if (this.props.onSaved) {
            this.props.onSaved();
          }
        }
      });
    }
    else {
      toastr.error('Please enter valid values');
    }
  }

  handleDeleteUser(){
    if(confirm('Are you sure you want to delete this user?')){
      this.setState({waitingUpdate: true});
      this.props.dispatch(deleteUser(this.state.selectedUser, this.state.syncToB2C)).then(x => {
        if(!(x.error || x.data.Message)){
          if (this.props.onDeleted) {
            this.props.onDeleted();
          }
        }
      });
    }
  }

  handleCommunicationNotificationFieldChange = e => {
    this.setState(prevState => {
      prevState.selectedUser.userNotificationCommunications = [...mustBeArray(e)];
      return prevState;
    });
  }

  loadUser(id) {
    this.setState({
      selectedUser: null,
      waitingUpdate: true,
    }, () => {
      apiRequest(`/api/users/${id || this.props.userId}`)
        .then(x => {
          let selectedCommunications = mustBeArray(x.data && x.data.userContact && x.data.userContact.communications).map(data => {
            let tempData = {userId: this.props.userId, communicationId: data.id, notificationType: 1, type: data.communicationType,  name: data.detail};
            const communicationTypePreviouslySelected = [...mustBeArray(x.data && x.data.userNotificationCommunications)].find(o => o.communicationId === tempData.communicationId);
            tempData.id = communicationTypePreviouslySelected ? communicationTypePreviouslySelected.id : 0;
            return tempData;
          });
          this.setState({
          selectedUser: x.data,
          waitingUpdate: false,
          communicationNotificationList: selectedCommunications,
        });
      });
    });
  }

  componentDidMount() {
    if(this.props.userId == EMPTY_GUID){
      this.setState({
        selectedUser: {
          userId: EMPTY_GUID,
          userName: '',
          roles: [],
          isActive: true,
          userContact: {id: -1, firstName: '', lastName: '', addresses: [], communications: [], notes: [], attachments: []},
          userNotificationCommunications: []
        },
      });
    } else {
      this.loadUser();
    }
  }

  // Send invite to external provider
  handleSendInvite = () => {
    this.setState({ sendInviteLoading: true});
    const {selectedUser} = this.state;
    const payLoad = {
      emailAddress: selectedUser && selectedUser.userName,
      userId: selectedUser && selectedUser.userId
    };
    this.props.dispatch(inviteExternalUsers({payLoad})).then(x => {
      this.setState({ sendInviteLoading:false });
      if(!requestHasError({x})){
        toastr.success("Invite sent");
      }
    });
  }

  redirectToDefaultRoute = () => {
    const {selectedUser} = this.state; 
    this.props.dispatch(push(`${BASE_URL}/manage/users/${selectedUser && selectedUser.userId}`));
  }

  render(){
    let {selectedUser, communicationNotificationList} = this.state;
    let {roles, account, apiConfig} = this.props;
    const isUserSuperUser = mustBeArray(selectedUser && selectedUser.roles).find(o => o.roleName === ROLE_SuperUser);
    const editMode = selectedUser && selectedUser.userId != EMPTY_GUID ? true : false;
    const selectedNotifications = mustBeArray(selectedUser && selectedUser.userNotificationCommunications).reduce((a,b) =>  a.concat(b.communicationId),[]);
    const roleOptions = 
        IsInRole(account, ROLE_SuperUser) || IsInRole(account, ROLE_Admin)
              ? roles.items
              : roles.items.filter((x) => x.roleName !== ROLE_Admin && x.roleName !== ROLE_SuperUser);

    return (selectedUser ? <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-6 col-md-12 col-lg-12">
            <h4>{ editMode ? 'Edit User' : 'Create User'}&nbsp;{this.props.onCancelled && <Button color="seconday" onClick={()=> this.props.onCancelled()}><i className="fa fa-mail-reply" />&nbsp;</Button> }</h4>
          </div>
        </div>        
        { (!IsCurrentUser(account, selectedUser) && IsInRole(account, ROLE_SuperUser)) && <div className="row">
          <div className="col-md-12">
            {selectedUser.canDelete && <Button color="danger" onClick={this.handleDeleteUser}><i className="fa fa-trash" />&nbsp;Delete User</Button>}
            {!selectedUser.canDelete && selectedUser.userId != EMPTY_GUID && <span>This user can't be deleted as it is assigned to a {selectedUser.driverId > 0 && <span>driver</span>} {selectedUser.bdmId > 0 && <span>BDM</span>}</span>}
          </div>
        </div> }
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            {selectedUser.isLockedOut &&
              <Button color="success" onClick={() => this.props.dispatch(unlockUser(selectedUser))}>
                <i className="fa fa-trash" />&nbsp;Unlock User</Button>}
          </div>
        </div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-6 col-md-12">
            <div className="form-horizontal">
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="name">User name</label>
                <div className="col-md-8">
                  {selectedUser.userId == EMPTY_GUID || allowUserWithRoles(account, [ROLE_SuperUser, ROLE_Admin]) ?
                    <Input type="text"
                           value={selectedUser.userName}
                           onChange={this.handleUserFieldChange}
                           name="userName"
                           placeholder="User name"
                    /> :
                    <Input type="text"
                           disabled
                           value={selectedUser.userName}
                           name="userName"
                           placeholder="User name"
                    />
                  }
                </div>
              </div>
              { allowUserWithRoles(account, [ROLE_SuperUser,ROLE_Admin, ROLE_OfficeUser]) && <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="collectionType">Roles</label>
                <div className="col-md-8">
                  <Select
                    name="roles"
                    value={selectedUser.roles}
                    multi
                    options={roleOptions}
                    onChange={this.handleRoleChange}
                    labelKey={"roleName"}
                    valueKey={"roleId"}
                  />
                </div>
              </div> }

              { account && !selectedUser.externalProvider && <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="isActive">Is active</label>
                <div className="col-md-6">
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox"
                             onChange={(e)=> this.setState({selectedUser: {...selectedUser, isActive: e.target.checked}})}
                             checked={selectedUser.isActive}
                             name="isActive"
                             disabled={IsCurrentUser(account, selectedUser)}
                      />
                    </Label>
                  </FormGroup>
                </div>
              </div> }
              { IsInRole(account, ROLE_SuperUser) && editMode && <div className="form-group row">
                <label className="col-md-2 form-control-label" htmlFor="syncToB2C">Sync to Azure AD B2C</label>
                <div className="col-md-8">
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox"
                             name="syncToB2C"
                             checked={this.state.syncToB2C}
                             onChange={(e)=> this.setState({syncToB2C: e.target.checked})}
                      />
                      &nbsp;<span className="text-muted">Uncheck to save or delete this user without updating Azure AD B2C.</span>
                    </Label>
                  </FormGroup>
                  { this.state.syncToB2C && <FormGroup check>
                    <Label check>
                      <Input type="checkbox"
                             name="createB2CIfNotExists"
                             checked={this.state.createB2CIfNotExists}
                             onChange={(e)=> this.setState({createB2CIfNotExists: e.target.checked})}
                      />
                      &nbsp;<span className="text-muted">Create the B2C account if it does not already exist.</span>
                    </Label>
                  </FormGroup> }
                </div>
              </div> }
              {
                isUserSuperUser && editMode &&
                <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="collectionType">Send delivery notifications to</label>
                  <div className="col-md-8">
                    <Select
                      name="communicationNotificationTypes"
                      value={selectedNotifications}
                      multi
                      options={communicationNotificationList}
                      onChange={e => this.handleCommunicationNotificationFieldChange(e)}
                      labelKey={"name"}
                      valueKey={"communicationId"}
                    />
                  </div>
              </div>
              }
              {(selectedUser.userId != EMPTY_GUID && !selectedUser.externalProvider) && <div className="form-group row">
                <div className="offset-md-2 col-md-8">
                  {!this.state.isResetPassword && <a href="#" onClick={(e)=> {e.preventDefault();this.setState({isResetPassword: true});}}>Reset Password</a>}
                  {this.state.isResetPassword && <a href="#" onClick={(e)=> {e.preventDefault();
                      this.setState({isResetPassword: false, selectedUser: {...selectedUser, newPassword: '', confirmedNewPassword: ''}});}}>Cancel Reset Password</a>}
                  </div>
              </div>}
              {selectedUser.externalProvider && <div className="form-group row">
                <Button color="success" className={`${this.state.sendInviteLoading ? "no-pointer-events" : ""}`} onClick={this.handleSendInvite}>
                  Send Invite
                </Button>
              </div>}

              <Collapse isOpen={this.state.isResetPassword}>
                <div className="form-group row">
                  <label className="col-md-2 form-control-label"  htmlFor="name">{this.state.isResetPassword && <span>New </span>}Password</label>
                  <div className="col-md-8">
                    <Input type="password"
                           value={selectedUser.newPassword}
                           onChange={this.handleUserFieldChange}
                           name="newPassword"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 form-control-label"  htmlFor="name">Confirm Password</label>
                  <div className="col-md-8">
                    <Input type="password"
                           value={selectedUser.confirmedNewPassword}
                           onChange={this.handleUserFieldChange}
                           name="confirmedNewPassword"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 form-control-label"> </label>
                  <div className="col-md-8">
                    <PasswordStrengthInstruction passwordStrength={apiConfig && apiConfig.passwordStrength}/>
                  </div>
                </div>
              </Collapse>


              {selectedUser && selectedUser.userContact && 
              <ContactView
                contact={selectedUser.userContact}
                isEdit
                ref={this.contactRef}
                manageUser={true}
                selectedRoles = {selectedUser && selectedUser.roles}
                userId = {selectedUser && selectedUser.userId}
              /> }

              
              <div>&nbsp;</div>
                <UserClientLocationControl
                  user={selectedUser}
                  onSelect={(x) => this.props.dispatch(push(x))}
                  ref={this.userLocationsRef}
                  userId={selectedUser.userId}
                  account={this.props.account}
                  requestsUpdated={() => {
                    setTimeout(this.loadUser, 1000);
                    this.props.dispatch(loadUsers());
                  }}
                  redirectToDefaultRoute={this.redirectToDefaultRoute}
                />
              

              <div className="form-group row">&nbsp;</div>
              <div className="form-group row">
                <div className="col-md-12">
                  {((this.state.isResetPassword && selectedUser.newPassword.trim() != '' && selectedUser.confirmedNewPassword == selectedUser.newPassword)
                    || (!this.state.isResetPassword && selectedUser.userId != EMPTY_GUID)
                    || (!this.state.isResetPassword && selectedUser.userId == EMPTY_GUID && selectedUser.userName.trim() != ''))
                  &&
                  <Button color="primary" onClick={this.handleSaveUser}><i className="fa fa-save" />&nbsp;Save User</Button>}&nbsp;
                  {this.props.onCancelled && <Button color="seconday" onClick={()=> this.props.onCancelled()}><i className="fa fa-mail-reply" />&nbsp;</Button> }
                </div>
              </div>




            </div>
          </div>
        </div>
      </div> : null);
  }
}

ManageUserControl.propTypes = {
  userId: PropTypes.string.isRequired,
  roles: PropTypes.object.isRequired,
  onSaved: PropTypes.func,
  onDeleted: PropTypes.func,
  onCancelled: PropTypes.func,
};

function mapStateToProps(state, ownProps){
  return {
    roles: state.roles,
    users: state.users,
    userId: ownProps.routeParams.id,
    account: state.account,
    apiConfig: state.apiConfig
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageUserControl));
